import { initPolyfills, initSentry, withSentryUserData, wrapWithLoginPopup, wrapWithSubscriptionCheckout, initializeReactApp } from "./entry-helper";
import VBErrorBoundary from "@vb-js-commons/vbErrorBoundaryHandler";
import ComplementInfo from "./login/complementinfo.js";
import PriceMap from "./treebula/price-map";
import Error404 from "./vb-django/pages/Error404";
// Other pages
import FAQPage from "./vb-django/pages/FAQPage";
import ForestCataloguePage from "./vb-django/pages/ForestCatalogue";
import ContactSellerPage from "./vb-django/pages/ContactSeller";
import ProfileEditPage from "./vb-django/pages/ProfileEdit";
import UserSettingsPage from "./vb-django/pages/UserSettingsPage";
import SBPToPdf from "./vb-django/pages/SBPToPdf";
import PricingPage from "./vb-django/components/minskog/aragon/PricingPage.js";
// Auctions
import AuctionDetailsPage from "./vb-django/pages/auctions/AuctionDetails.js";
import AuctionsCreatePage from "./vb-django/pages/auctions/AuctionsCreate.js";
import Auctions from "./vb-django/pages/auctions/Auctions";
// Naturehub
import NHListings from "./vb-django/pages/naturehub/nhListings.js";
import NHDetails from "./vb-django/pages/naturehub/nhDetails.js";
import NHCreate from "./vb-django/pages/naturehub/nhCreate.js";
// Map service layer upload
import UserMapLayerUpload from "./vb-django/pages/UserMapLayerUpload.js";
// Typeform
import Typeform from "./vb-django/pages/TypeformPage/index.js";
import BookDemoForm from "./vb-django/pages/TypeformPage/BookDemoForm.js";
// Form Modal
import LoginFormModal from "./vb-django/forms/LoginFormModal.js";
// Pricecomparison
import PriceComparison from "./vb-django/components/pricecomparisonold/PriceComparison.js";
import UnderConstruction from "./vb-django/pages/UnderConstruction.js";

initSentry();
initPolyfills();

const components = {
  VBErrorBoundary: withSentryUserData(VBErrorBoundary),

  ComplementInfo: wrapWithLoginPopup(wrapWithSubscriptionCheckout(withSentryUserData(ComplementInfo))),
  PriceMap: wrapWithLoginPopup(wrapWithSubscriptionCheckout(withSentryUserData(PriceMap))),
  Error404: wrapWithLoginPopup(wrapWithSubscriptionCheckout(withSentryUserData(Error404))),

  FAQPage: wrapWithLoginPopup(wrapWithSubscriptionCheckout(withSentryUserData(FAQPage))),
  ForestCataloguePage: wrapWithLoginPopup(wrapWithSubscriptionCheckout(withSentryUserData(ForestCataloguePage))),
  ContactSellerPage: wrapWithLoginPopup(wrapWithSubscriptionCheckout(withSentryUserData(ContactSellerPage))),
  ProfileEditPage: wrapWithLoginPopup(wrapWithSubscriptionCheckout(withSentryUserData(ProfileEditPage))),
  UserSettingsPage: wrapWithLoginPopup(wrapWithSubscriptionCheckout(withSentryUserData(UserSettingsPage))),
  SBPToPdf: withSentryUserData(SBPToPdf),

  NHListings: wrapWithLoginPopup(wrapWithSubscriptionCheckout(withSentryUserData(NHListings))),
  NHDetails: wrapWithLoginPopup(wrapWithSubscriptionCheckout(withSentryUserData(NHDetails))),
  NHCreate: wrapWithLoginPopup(wrapWithSubscriptionCheckout(withSentryUserData(NHCreate))),

  UserMapLayerUpload: wrapWithLoginPopup(wrapWithSubscriptionCheckout(UserMapLayerUpload)),

  Typeform: wrapWithLoginPopup(wrapWithSubscriptionCheckout(withSentryUserData(Typeform))),
  BookDemoForm: wrapWithLoginPopup(wrapWithSubscriptionCheckout(withSentryUserData(BookDemoForm))),

  AuctionDetailsPage: wrapWithLoginPopup(wrapWithSubscriptionCheckout(withSentryUserData(AuctionDetailsPage))),
  AuctionsCreatePage: wrapWithLoginPopup(wrapWithSubscriptionCheckout(withSentryUserData(AuctionsCreatePage))),
  Auctions: wrapWithLoginPopup(wrapWithSubscriptionCheckout(withSentryUserData(Auctions))),

  LoginFormModal: withSentryUserData(LoginFormModal),

  PriceComparison: wrapWithLoginPopup(wrapWithSubscriptionCheckout(withSentryUserData(PriceComparison))),
  UnderConstruction: withSentryUserData(UnderConstruction),
  PricingPageLoggedOut: wrapWithLoginPopup(wrapWithSubscriptionCheckout(withSentryUserData(PricingPage))),
};


initializeReactApp({
  componentName: null,
  componentFactory: (name) => components[name],
  skipComponents: ["MinSkog", "Editor", "PuckPageView"],
});

export default components;